<div class="form form--name-long form--full-width" [ngClass]="getLevelClass()">
  <div class="form__label">
    <basic-label [noIndent]="true"></basic-label>
  </div>

  <div class="form__inline-field-container">
    <div class="form__field">
      <basic-text-input
        [propertyName]="getCustomProp(0)"
        [placeholder]="getPlaceholder(0) || 'First'"
      ></basic-text-input>
    </div>
    <div class="form__field">
      <basic-text-input
        [propertyName]="getCustomProp(1)"
        [placeholder]="getPlaceholder(1) || 'Middle'"
      ></basic-text-input>
    </div>
    <div class="form__field">
      <basic-text-input
        [propertyName]="getCustomProp(2)"
        [placeholder]="getPlaceholder(2) || 'Last'"
      ></basic-text-input>
    </div>
  </div>
</div>
